import PropTypes from 'prop-types';
import React, { createRef } from "react";

import { defineMessages, injectIntl } from 'react-intl';

import classNames from 'classnames';
import { withRouter } from 'react-router-dom';

import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import ImmutablePureComponent from 'react-immutable-pure-component';
import { connect } from 'react-redux';

import { debounce } from 'lodash';

import { showAlert } from 'mastodon/actions/alerts';
import { openShareModal } from 'mastodon/actions/share';
import {
  closeCommentForm,
  closeReplyCommentForm,
  openCommentForm,
  openReplyCommentForm
} from 'mastodon/actions/comment_form';
import { clearComposeAll, resetCompose } from "mastodon/actions/compose";
import { apiGetFavouritedBy } from 'mastodon/api/status';
import Comment_form_container from "mastodon/features/compose/containers/comment_form_container";
import { handleFavouriteTooltipClick } from 'mastodon/features/status/components/detailed_status';
import FavouritesTooltip from 'mastodon/features/status/components/favourites_tooltip';
import { identityContextPropShape, withIdentity } from 'mastodon/identity_context';
import { PERMISSION_MANAGE_USERS, PERMISSION_MANAGE_FEDERATION } from 'mastodon/permissions';
import { WithRouterPropTypes } from 'mastodon/utils/react_router';

import DropdownMenuContainer from '../containers/dropdown_menu_container';
import { me } from '../initial_state';

import { IconButton } from './icon_button';
import { closeModal, openModal } from 'mastodon/actions/modal';
import { CommentIcon } from './icons/comment';
import { ShareIcon } from './icons/share';
import { LikeIcon } from './icons/like';
import { MoreHorizIcon } from './icons/more_horiz';
import { LikeActiveIcon } from './icons/like_active';
import { RelativeTimestamp } from './relative_timestamp';
import { ExpandUpIcon } from './icons/expand_up';
import { ExpandDownIcon } from './icons/expand_down';
import { Avatar } from './avatar';
import { LoadingIndicator } from './loading_indicator';
import { createPortal } from 'react-dom';

const activeTooltip = { statusId: null, instance: null };

const messages = defineMessages({
  view: { id: 'status.view', defaultMessage: 'View' },
  delete: { id: 'status.delete', defaultMessage: 'Delete' },
  redraft: { id: 'status.redraft', defaultMessage: 'Delete & re-draft' },
  edit: { id: 'status.edit', defaultMessage: 'Edit' },
  direct: { id: 'status.direct', defaultMessage: 'Privately mention {name}' },
  mention: { id: 'status.mention', defaultMessage: 'Mention {name}' },
  mute: { id: 'account.mute', defaultMessage: 'Mute {name}' },
  block: { id: 'account.block', defaultMessage: 'Block {name}' },
  reply: { id: 'status.reply', defaultMessage: 'Reply' },
  openCompose: { id: 'compose.published.open', defaultMessage: 'Open' },
  share: { id: 'status.share', defaultMessage: 'Share' },
  more: { id: 'status.more', defaultMessage: 'More' },
  shared: { id: 'status.shared', defaultMessage: 'Shared' },
  reblogged: { id: 'status.reblogged', defaultMessage: 'Boosted' },
  replyAll: { id: 'status.replyAll', defaultMessage: 'Reply to thread' },
  reblog: { id: 'status.reblog', defaultMessage: 'Boost' },
  reblog_private: { id: 'status.reblog_private', defaultMessage: 'Boost with original visibility' },
  cancel_reblog_private: { id: 'status.cancel_reblog_private', defaultMessage: 'Unboost' },
  cannot_reblog: { id: 'status.cannot_reblog', defaultMessage: 'This post cannot be boosted' },
  favourite: { id: 'status.favourite', defaultMessage: 'Favorite' },
  removeFavourite: { id: 'status.remove_favourite', defaultMessage: 'Remove from favorites' },
  bookmark: { id: 'status.bookmark', defaultMessage: 'Bookmark' },
  removeBookmark: { id: 'status.remove_bookmark', defaultMessage: 'Remove bookmark' },
  open: { id: 'status.open', defaultMessage: 'Expand this status' },
  report: { id: 'status.report', defaultMessage: 'Report {name}' },
  muteConversation: { id: 'status.mute_conversation', defaultMessage: 'Mute conversation' },
  unmuteConversation: { id: 'status.unmute_conversation', defaultMessage: 'Unmute conversation' },
  pin: { id: 'status.pin', defaultMessage: 'Pin on profile' },
  unpin: { id: 'status.unpin', defaultMessage: 'Unpin from profile' },
  embed: { id: 'status.embed', defaultMessage: 'Get embed code' },
  admin_account: { id: 'status.admin_account', defaultMessage: 'Open moderation interface for {name}' },
  admin_status: { id: 'status.admin_status', defaultMessage: 'Open this post in the moderation interface' },
  admin_domain: { id: 'status.admin_domain', defaultMessage: 'Open moderation interface for {domain}' },
  blockDomain: { id: 'account.block_domain', defaultMessage: 'Block domain {domain}' },
  unblockDomain: { id: 'account.unblock_domain', defaultMessage: 'Unblock domain {domain}' },
  unmute: { id: 'account.unmute', defaultMessage: 'Unmute {name}' },
  unblock: { id: 'account.unblock', defaultMessage: 'Unblock {name}' },
  filter: { id: 'status.filter', defaultMessage: 'Filter this post' },
  comment: { id: 'status.comment', defaultMessage: 'Comment' },
  like: { id: 'status.like', defaultMessage: 'Like' },
  openOriginalPage: { id: 'account.open_original_page', defaultMessage: 'Open original page' },
  hideReply: { id: 'status.hide_reply', defaultMessage: 'Hide Replies' },
  showMoreReply: { id: 'status.show_more_comments', defaultMessage: "See more replies" }
});

const mapStateToProps = (state, { status }) => {
  const contexts = state.getIn(['contexts', 'contexts'], Immutable.Map());
  const descendants = contexts.get('descendants', Immutable.List());

  return {
    relationship: state.getIn(['relationships', status?.getIn(['account', 'id'])]),
    descendants,
    meAccount: state.getIn(['accounts', me])
  };
};

class StatusActionBar extends ImmutablePureComponent {
  static propTypes = {
    isNotification: PropTypes.bool,
    childRepliesSize: PropTypes.number,
    isReplyExpand: PropTypes.bool,
    expandReply: PropTypes.func,
    replyLevel: PropTypes.number,
    identity: identityContextPropShape,
    dispatch: PropTypes.func.isRequired,
    status: ImmutablePropTypes.map.isRequired,
    relationship: ImmutablePropTypes.record,
    onReply: PropTypes.func,
    onFavourite: PropTypes.func,
    onReblog: PropTypes.func,
    onDelete: PropTypes.func,
    onDirect: PropTypes.func,
    onMention: PropTypes.func,
    onMute: PropTypes.func,
    onUnmute: PropTypes.func,
    onBlock: PropTypes.func,
    onUnblock: PropTypes.func,
    onBlockDomain: PropTypes.func,
    onUnblockDomain: PropTypes.func,
    onReport: PropTypes.func,
    onEmbed: PropTypes.func,
    onMuteConversation: PropTypes.func,
    onPin: PropTypes.func,
    onBookmark: PropTypes.func,
    onFilter: PropTypes.func,
    onAddFilter: PropTypes.func,
    onInteractionModal: PropTypes.func,
    withDismiss: PropTypes.bool,
    withCounters: PropTypes.bool,
    scrollKey: PropTypes.string,
    intl: PropTypes.object.isRequired,
    onToggleReplies: PropTypes.func,
    onShowCommentForm: PropTypes.func,
    isComment: PropTypes.bool,
    featured: PropTypes.bool,
    isImageModal: PropTypes.bool,
    isVideoModal: PropTypes.bool,
    descendants: ImmutablePropTypes.list,
    ...WithRouterPropTypes,
  };

  // Avoid checking props that are functions (and whose equality will always
  // evaluate to false. See react-immutable-pure-component for usage.
  updateOnProps = [
    'status',
    'relationship',
    'withDismiss',
    'commentId',
    'isReplyExpand',
    'isComment',
    'childRepliesSize'
  ];
  state = {
    showReply: false,
    commendId: null,
    prevHighlightCommentId: null,
    showFavouritesTooltip: false,
    favourites: [],
    isFetchingFavourites: false,
    isTooltipHovered: false,
    justClosedOverlay: false,
    favouritesTooltipStyle: null,
  };

  handleReplyClick = () => {
    const { signedIn } = this.props.identity;
    if (signedIn) {

      const isReplyTo = this.props.status?.get('in_reply_to_id') !== null;
      this.props.dispatch(openCommentForm());
      if (isReplyTo) {
        this.props.onReply(this.props.status);
      } else {
        const { status, history } = this.props;
        const route = `/@${status?.getIn(['account', 'acct'])}/${status?.get('id')}`;
        history.push(route);
        this.props.dispatch(closeModal({ modalType: undefined, ignoreFocus: false }));
        this.props.dispatch(resetCompose());
        this.props.dispatch(openCommentForm());
        this.props.dispatch(closeReplyCommentForm());
        this.props.onReply(this.props.status);

      }
    } else {
      // this.props.onInteractionModal('reply', this.props.status);
      window.location.href = '/auth/laoid';
    }
  };

  handleReplyCommentClick = () => {
    const { signedIn } = this.props.identity;
    if (signedIn) {
      this.props.dispatch(clearComposeAll());
      this.props.dispatch(resetCompose());
      this.props.dispatch(openReplyCommentForm(this.props.status?.get('id')));
      this.props.dispatch(closeCommentForm());
      this.props.onReply(this.props.status);
      // this.props.onReplyComment(this.props.status);
    } else {
      // if (this.props.status?.get('in_reply_to_id')){
      //   this.props.onInteractionModal('replyComment', this.props.status);
      // } else {
      //   this.props.onInteractionModal('reply', this.props.status);
      // }
      window.location.href = '/auth/laoid';
    }
  };

  handleFavouriteClick = (e) => {
    const { signedIn } = this.props.identity;

    if (signedIn) {
      e.preventDefault();
      this.props.onFavourite(this.props.status);
    } else {
      // if (this.props.status?.get('in_reply_to_id')){
      //   this.props.onInteractionModal('favouriteComment', this.props.status);
      // } else {
      //   this.props.onInteractionModal('favourite', this.props.status);
      // }
      window.location.href = '/auth/laoid';
    }
  };

  handleReblogClick = e => {
    const { signedIn } = this.props.identity;
    const dispatch = this.props.dispatch;

    if (signedIn) {
      if (this.props.status?.get('reblogged')) {
        dispatch(showAlert({ message: this.props.intl.formatMessage(messages.reblogged) }));
      } else {
        dispatch(openShareModal(this.props.status?.get('id')));
      }

    } else {
      // this.props.onInteractionModal('reblog', this.props.status);
      window.location.href = '/auth/laoid';
    }
  };

  handleBookmarkClick = () => {
    this.props.onBookmark(this.props.status);
  };

  handleDeleteClick = () => {
    this.props.onDelete(this.props.status, false, true);
  };

  handleRedraftClick = () => {
    this.props.onDelete(this.props.status, true);
  };

  handleEditClick = () => {
    // this.props.dispatch(openCommentForm());
    const { signedIn } = this.props.identity;
    if (!signedIn) window.location.href = '/auth/laoid';
    this.props.onEdit(this.props.status);
  };

  handleCommentEditClick = () => {
    const { signedIn } = this.props.identity;
    if (!signedIn) window.location.href = '/auth/laoid';
    this.props.onEditComment(this.props.status);
  };

  handlePinClick = () => {
    const { featured, scrollKey, status } = this.props;
    const isShownAsPinned = featured || scrollKey === 'pinned_statuses';

    this.props.onPin(isShownAsPinned && !status?.get('pinned') ? status.set('pinned', true) : status);
  };

  handleMentionClick = () => {
    this.props.onMention(this.props.status?.get('account'));
    if (this.props.dispatch) {
      this.props.dispatch(closeModal({ modalType: undefined, ignoreFocus: false }));
      const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
      if (!isMobile) {
        this.props.dispatch(openModal({
          modalType: 'COMPOSE_FORM',
          modalProps: {},
        }));
      } else {
        window.dispatchEvent(new Event('showBottomSheet'));
      }
    }
  };

  handleDirectClick = () => {
    this.props.onDirect(this.props.status?.get('account'));
  };

  handleMuteClick = () => {
    const { status, relationship, onMute, onUnmute } = this.props;
    const account = status?.get('account');

    if (relationship && relationship.get('muting')) {
      onUnmute(account);
    } else {
      onMute(account);
    }
  };

  handleBlockClick = () => {
    const { status, relationship, onBlock, onUnblock } = this.props;
    const account = status?.get('account');

    if (relationship && relationship.get('blocking')) {
      onUnblock(account);
    } else {
      onBlock(status);
    }
  };

  handleBlockDomain = () => {
    const { status, onBlockDomain } = this.props;
    const account = status?.get('account');

    onBlockDomain(account);
  };

  handleUnblockDomain = () => {
    const { status, onUnblockDomain } = this.props;
    const account = status?.get('account');

    onUnblockDomain(account.get('acct').split('@')[1]);
  };

  handleOpen = () => {
    this.props.history.push(`/@${this.props.status?.getIn(['account', 'acct'])}/${this.props.status?.get('id')}`);
  };

  handleEmbed = () => {
    this.props.onEmbed(this.props.status);
  };

  handleReport = () => {
    this.props.onReport(this.props.status);
  };

  handleConversationMuteClick = () => {
    this.props.onMuteConversation(this.props.status);
  };

  handleFilterClick = () => {
    this.props.onAddFilter(this.props.status);
  };

  overlayRef = createRef();
  abortController = new AbortController();
  favouritesCache = {};
  isMobile = () => {
    return window.innerWidth < 630;
  };

  componentDidMount() {
    this._setupOverlay();
    window.addEventListener('mousedown', this.handleDocumentClick);
  }

  componentWillUnmount() {
    this.fetchFavourites.cancel();
    this.hideTooltip.cancel();
    window.removeEventListener('mousedown', this.handleDocumentClick);
    this.abortController.abort();
    if (activeTooltip.statusId === this.props.status?.get('id')) {
      activeTooltip.statusId = null;
      activeTooltip.instance = null;
    }
    this._cleanupOverlay();
  }

  setRef = c => {
    this.node = c;
  };

  setTooltipRef = c => {
    this.tooltipNode = c;
  };

  updateFavouritesTooltipPosition = () => {
    if (!this.node) {
      return;
    }

    const rect = this.node.getBoundingClientRect();
    const width = 240;
    const maxHeight = 300;
    const gap = 8;
    const viewportPadding = 8;
    const maxLeft = Math.max(viewportPadding, window.innerWidth - width - viewportPadding);
    const left = Math.min(Math.max(rect.left + (rect.width / 2) - (width / 2), viewportPadding), maxLeft);
    const shouldOpenAbove = rect.bottom + gap + maxHeight > window.innerHeight - viewportPadding;
    const top = shouldOpenAbove ? Math.max(viewportPadding + maxHeight, rect.top - gap) : rect.bottom + gap;

    this.setState({
      favouritesTooltipStyle: {
        position: 'fixed',
        top,
        left,
        width,
        zIndex: 100000,
        transform: shouldOpenAbove ? 'translateY(-100%)' : undefined,
      },
    });
  };

  handleDocumentClick = (e) => {
    if (
      this.state.showFavouritesTooltip &&
      this.node &&
      !this.node.contains(e.target) &&
      !this.tooltipNode?.contains(e.target)
    ) {
      this.fetchFavourites.cancel();
      this.hideTooltip.cancel();
      this.setState({ showFavouritesTooltip: false, isTooltipHovered: false });
      if (activeTooltip.statusId === this.props.status?.get('id')) {
        activeTooltip.statusId = null;
        activeTooltip.instance = null;
      }
    }
  };

  hideTooltip = debounce(() => {
    if (!this.state.isTooltipHovered) {
      this.fetchFavourites.cancel();
      this.setState({ showFavouritesTooltip: false });
      if (activeTooltip.statusId === this.props.status?.get('id')) {
        activeTooltip.statusId = null;
        activeTooltip.instance = null;
      }
    }
  }, 300);

  isFetchingRef = { current: false };

  fetchFavourites = debounce(
    async () => {
      const statusId = this.props.status?.get('id');

      if (this.favouritesCache[statusId]) {
        this.setState({ favourites: this.favouritesCache[statusId], showFavouritesTooltip: true });
        return;
      }
      if (this.isFetchingRef.current) return;

      this.isFetchingRef.current = true;
      this.abortController.abort();
      this.abortController = new AbortController();

      this.setState({ isFetchingFavourites: true });
      try {
        const data = await apiGetFavouritedBy(this.props.status?.get('id'), this.abortController.signal);
        this.favouritesCache[statusId] = data;
        this.setState({ favourites: data, isFetchingFavourites: false });
        if (data && data.length > 0 && activeTooltip.statusId === statusId && !this.isMobile()) {
          this.setState({ showFavouritesTooltip: true });
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Failed to fetch favourites:', error);
          this.setState({ favourites: [], isFetchingFavourites: false });
        }
      } finally {
        this.isFetchingRef.current = false;
      }
    },
    500,
    { leading: false, trailing: true },
  );

  handleFavouriteTooltip = () => {
    const statusId = this.props.status?.get('id');
    this.fetchFavourites.cancel();
    this.abortController.abort();
    this.abortController = new AbortController();
    this.isFetchingRef.current = false;
    delete this.favouritesCache[statusId];
    handleFavouriteTooltipClick(
      this.props.status,
      this.props.dispatch,
      { current: this.favouritesCache },
      (favourites) => this.setState({ favourites }),
      (isFetchingFavourites) => this.setState({ isFetchingFavourites }),
      this.props.meAccount?.toJS()
    );
  };


  handleFavouriteMouseEnter = () => {
    if (this.isMobile()) return;

    if (activeTooltip.instance && activeTooltip.instance !== this) {
      activeTooltip.instance.fetchFavourites.cancel();
      activeTooltip.instance.hideTooltip.cancel();
      activeTooltip.instance.setState({ showFavouritesTooltip: false, isTooltipHovered: false });
    }

    activeTooltip.statusId = this.props.status?.get('id');
    activeTooltip.instance = this;

    this.updateFavouritesTooltipPosition();
    this.setState({ showFavouritesTooltip: true });
    this.fetchFavourites();
    this.hideTooltip.cancel();
  };

  handleFavouriteMouseLeave = () => {
    if (this.isMobile()) return;

    if (!this.state.isTooltipHovered) {
      this.hideTooltip();
    }
  };

  handleTooltipMouseEnter = () => {
    if (this.isMobile()) return;

    this.setState({ isTooltipHovered: true });
    this.hideTooltip.cancel();
  };

  handleTooltipMouseLeave = () => {
    if (this.isMobile()) return;

    this.setState({ isTooltipHovered: false });
    this.hideTooltip();
  };

  renderFavouritesTooltip = (status) => {
    if (!this.state.showFavouritesTooltip || this.isMobile() || !this.state.favouritesTooltipStyle) {
      return null;
    }

    return createPortal(
      <div
        ref={this.setTooltipRef}
        className='favourites-tooltip-wrapper favourites-tooltip-wrapper--portal'
        style={this.state.favouritesTooltipStyle}
        onMouseEnter={this.handleTooltipMouseEnter}
        onMouseLeave={this.handleTooltipMouseLeave}
      >
        {this.state.isFetchingFavourites ? (
          <div className='favourites-tooltip-loading'>
            <LoadingIndicator />
          </div>
        ) : (
          this.state.favourites && this.state.favourites.length > 0 && (
            <FavouritesTooltip accounts={this.state.favourites} totalCount={status?.get('favourites_count')} intl={this.props.intl} />
          )
        )}
      </div>,
      document.body,
    );
  };



  componentDidUpdate(prevProps) {
    const { status, replyLevel, expandReply, isReplyExpand, childRepliesSize, descendants, commentId } = this.props;
    const urlParams = new URLSearchParams(this.props.location.search);
    const highlightCommentId = urlParams.get('highlightCommentId');
    const ancestorIds = urlParams.get('ancestorIds')?.split(',') || [];

    // Invalidate favourites cache when the like count changes (like ↔ unlike)
    const prevCount = prevProps.status?.get('favourites_count');
    const nextCount = status?.get('favourites_count');
    if (prevCount !== nextCount) {
      const statusId = status?.get('id');
      if (statusId && this.favouritesCache[statusId]) {
        delete this.favouritesCache[statusId];
        this.setState({ favourites: [] });
      }
    }

    if (commentId !== this.state.commentId && !this.state.justClosedOverlay) {
      this.setState({ commentId });
      this._toggleOverlay(commentId === status?.get('id'));
    }

    this.setState({
      ...this.state, commentId: this.props.commentId
    });

    const prevHighlightCommentId = this.state.prevHighlightCommentId;

    if (highlightCommentId !== prevHighlightCommentId) {
      if (
        highlightCommentId &&
        childRepliesSize > 0
      ) {

        if (descendants && descendants.size > 0) {
          const comment = descendants.find((desc) => desc.get('id').toString() === highlightCommentId);
          if (comment) {
            const parentIds = [];
            let currentId = comment.get('in_reply_to_id');

            while (currentId) {
              const parent = descendants.find((desc) => desc.get('id').toString() === currentId);
              if (parent) {
                parentIds.push(currentId);
                currentId = parent.get('in_reply_to_id');
              } else {
                console.warn(`Parent ${currentId} not found in descendants`);
                break;
              }
            }

            parentIds.reverse().forEach((parentId, index) => {
              setTimeout(() => {
                expandReply(parentId, true);
              }, index * 100);
            });
          } else {
            console.warn(`Comment with highlightCommentId ${highlightCommentId} not found in descendants`);
          }
        }

        if (ancestorIds.length > 0) {
          ancestorIds.forEach((ancestorId) => {
            if (ancestorId === status?.get('id')) {
              expandReply(ancestorId, true);
            }
          });
        }

      } else if (prevHighlightCommentId && !highlightCommentId && isReplyExpand) {
        expandReply(status?.get('id'), false);
      }

      this.setState({
        prevHighlightCommentId: highlightCommentId,
      });
    }
  }

  _setupOverlay = () => {
    if (window.innerWidth <= 768) {
      const overlay = document.createElement('div');
      overlay.className = 'reply-comment-overlay';
      overlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(24, 24, 33, 0.5);
        z-index: 1000;
        opacity: 0;
        transition: opacity 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        backdrop-filter: blur(0);
        -webkit-backdrop-filter: blur(0);
        pointer-events: none;
      `;
      overlay.addEventListener('click', () => {
        this.props.dispatch(closeCommentForm());
        this.props.dispatch(closeReplyCommentForm());
        this.setState({ commentId: null, justClosedOverlay: true }, () => {
          setTimeout(() => this.setState({ justClosedOverlay: false }), 100);
        });
        this._toggleOverlay(false);
      });
      document.body.appendChild(overlay);
      this.overlayRef.current = overlay;
      if (this.props.commentId === this.props.status?.get('id')) {
        this._toggleOverlay(true);
      }
    }
  };

  _toggleOverlay = (show) => {
    if (this.overlayRef.current) {
      this.overlayRef.current.style.opacity = show ? '1' : '0';
      this.overlayRef.current.style.pointerEvents = show ? 'auto' : 'none';
    }
  };

  _cleanupOverlay = () => {
    if (this.overlayRef.current) {
      document.body.removeChild(this.overlayRef.current);
      this.overlayRef.current = null;
    }
  };

  render() {
    const { status, relationship, intl, withDismiss, scrollKey } = this.props;
    const { signedIn, permissions } = this.props.identity;

    const publicStatus = ['public', 'unlisted'].includes(status?.get('visibility'));
    const pinnableStatus = ['public', 'unlisted', 'private'].includes(status?.get('visibility'));
    const mutingConversation = status?.get('muted');
    const account = status?.get('account');
    const writtenByMe = status?.getIn(['account', 'id']) === me;
    const sharedByMe = status?.get('reblog') && writtenByMe;
    const isShownAsPinned = this.props.featured || scrollKey === 'pinned_statuses';
    const isPinnedStatus = status?.get('pinned') || isShownAsPinned;
    const canPinStatus = writtenByMe && pinnableStatus && !isPinnedStatus;
    const canUnpinStatus = (writtenByMe || sharedByMe) && isPinnedStatus;
    const isRemote = status?.getIn(['account', 'username']) !== status?.getIn(['account', 'acct']);
    const bookmarkTitle = intl.formatMessage(status?.get('bookmarked') ? messages.removeBookmark : messages.bookmark);

    let menu = [];
    if (this.props.isNotification) {
      if (signedIn && !writtenByMe) {
        menu.push({
          text: intl.formatMessage(messages.report, { name: account.get('display_name') }),
          action: this.handleReport,
          dangerous: true
        });
      }
    } else if (this.props.isComment) {
      if (signedIn) {
        if (writtenByMe) {
          menu.push({ text: intl.formatMessage(messages.edit), action: this.handleCommentEditClick });
          menu.push({ text: intl.formatMessage(messages.delete), action: this.handleDeleteClick, dangerous: true });
        } else menu.push({
          text: intl.formatMessage(messages.report, { name: account.get('display_name') }),
          action: this.handleReport,
          dangerous: true
        });
      }
    } else {
      if (signedIn) {
        menu.push({ text: bookmarkTitle, action: this.handleBookmarkClick });
      }
      if (publicStatus && isRemote) {
        menu.push({ text: intl.formatMessage(messages.openOriginalPage), href: status?.get('url') });
      }
      if (signedIn) {
        if (canPinStatus || canUnpinStatus) {
          menu.push({
            text: intl.formatMessage(isPinnedStatus ? messages.unpin : messages.pin),
            action: this.handlePinClick
          });
        }
        menu.push(null);
        if (writtenByMe || withDismiss) {
          menu.push({
            text: intl.formatMessage(mutingConversation ? messages.unmuteConversation : messages.muteConversation),
            action: this.handleConversationMuteClick
          });
          menu.push(null);
        }
        if (writtenByMe) {
          menu.push({ text: intl.formatMessage(messages.edit), action: this.handleEditClick });
          menu.push({ text: intl.formatMessage(messages.delete), action: this.handleDeleteClick, dangerous: true });
          // menu.push({ text: intl.formatMessage(messages.redraft), action: this.handleRedraftClick, dangerous: true });
        } else {
          // menu.push({ text: intl.formatMessage(messages.mention, { name: account.get('display_name') }), action: this.handleMentionClick });
          // menu.push({ text: intl.formatMessage(messages.direct, { name: account.get('display_name') }), action: this.handleDirectClick });
          // menu.push(null);

          if (relationship && relationship.get('muting')) {
            menu.push({ text: intl.formatMessage(messages.unmute, { name: account.get('display_name') }), action: this.handleMuteClick });
          } else {
            menu.push({ text: intl.formatMessage(messages.mute, { name: account.get('display_name') }), action: this.handleMuteClick, dangerous: true });
          }

          if (relationship && relationship.get('blocking')) {
            menu.push({ text: intl.formatMessage(messages.unblock, { name: account.get('display_name') }), action: this.handleBlockClick });
          } else {
            menu.push({ text: intl.formatMessage(messages.block, { name: account.get('display_name') }), action: this.handleBlockClick, dangerous: true });
          }

          menu.push(null);
          menu.push({ text: intl.formatMessage(messages.report, { name: account.get('display_name') }), action: this.handleReport, dangerous: true });

          if (account.get('acct') !== account.get('username')) {
            const domain = account.get('acct').split('@')[1];

            menu.push(null);

            if (relationship && relationship.get('domain_blocking')) {
              menu.push({ text: intl.formatMessage(messages.unblockDomain, { domain }), action: this.handleUnblockDomain });
            } else {
              menu.push({ text: intl.formatMessage(messages.blockDomain, { domain }), action: this.handleBlockDomain, dangerous: true });
            }
          }

          if ((permissions & PERMISSION_MANAGE_USERS) === PERMISSION_MANAGE_USERS || (isRemote && (permissions & PERMISSION_MANAGE_FEDERATION) === PERMISSION_MANAGE_FEDERATION)) {
            menu.push(null);
            if (isRemote && (permissions & PERMISSION_MANAGE_FEDERATION) === PERMISSION_MANAGE_FEDERATION) {
              const domain = account.get('acct').split('@')[1];
              menu.push({ text: intl.formatMessage(messages.admin_domain, { domain: domain }), href: `/admin/instances/${domain}` });
            }
          }
        }
      }
    }

    let replyIcon;
    let replyTitle;

    if (status?.get('in_reply_to_id', null) === null) {
      replyIcon = 'reply';
      replyTitle = intl.formatMessage(messages.reply);
    } else {
      replyIcon = 'reply-all';
      replyTitle = intl.formatMessage(messages.replyAll);
    }

    const reblogPrivate = status?.getIn(['account', 'id']) === me && status?.get('visibility') === 'private';

    let reblogTitle;

    if (status?.get('reblogged')) {
      reblogTitle = intl.formatMessage(messages.cancel_reblog_private);
    } else if (publicStatus) {
      reblogTitle = intl.formatMessage(messages.reblog);
    } else if (reblogPrivate) {
      reblogTitle = intl.formatMessage(messages.reblog_private);
    } else {
      reblogTitle = intl.formatMessage(messages.cannot_reblog);
    }
    const favouriteTitle = intl.formatMessage(status?.get('favourited') ? messages.removeFavourite : messages.favourite);
    const isReply = status?.get('in_reply_to_account_id') === status?.getIn(['account', 'id']);
    const isReplyTo = status?.get('in_reply_to_id') !== null;

    const handleShowReply = () => {
      if (this.props.expandReply && status) {
        this.props.expandReply(status?.get('id'));
      }
    };

    const postActionBar = (
      <>
        {(!this.props.isImageModal || !this.props.isVideoModal) && (
          <div className='status__action-bar'
            style={{ justifyContent: status?.get('reblog') ? 'space-around' : 'space-between' }}>

            <div style={{ width: '100%', display: 'flex', justifyContent: 'start', alignItems: 'center', gap: '10px' }}>
              <div className='status__action-bar__button-wrapper'
                style={!this.props.isComment ? {
                  backgroundColor: 'var(--surface-variant-background-color)',
                  padding: '6px 12px',
                } : {
                  position: 'absolute !important',
                  right: '0 !important'
                }}
              >
                <IconButton className='status__action-bar__button ' animate active={status?.get('favourited')}
                  title={favouriteTitle} icon='star' iconComponent={status?.get('favourited') ? LikeActiveIcon : LikeIcon}
                  onClick={this.handleFavouriteClick} style={{ touchAction: 'manipulation', userSelect: 'none' }} />
                <span className='interaction__bar-item interaction__bar_like' style={{ cursor: 'pointer' }}>
                  {status?.get('favourites_count')}
                </span>
              </div>
              <div className='status__action-bar__button-wrapper'
                style={!this.props.isComment && {
                  backgroundColor: 'var(--surface-variant-background-color)',
                  padding: '6px 12px',
                }}
              >
                <IconButton className='status__action-bar__button' title={intl.formatMessage(messages.comment)} icon={isReply ? 'reply' : replyIcon}
                  iconComponent={CommentIcon} onClick={this.handleReplyClick}
                />
                <span className='interaction__bar-item' role='presentation'>
                  {status?.get('replies_count')}
                </span>
              </div>
              {!status?.get('reblog') && !status?.get('reblogged') && !status?.get('in_reply_to_id') && (<div className='status__action-bar__button-wrapper'
                style={!this.props.isComment && {
                  backgroundColor: 'var(--surface-variant-background-color)',
                  padding: '6px 12px',
                }}
              >
                <IconButton className={classNames('status__action-bar__button', { reblogPrivate })}
                  disabled={!publicStatus && !reblogPrivate} active={false} title={reblogTitle} icon='retweet'
                  iconComponent={ShareIcon} onClick={this.handleReblogClick}
                />
                <span className='interaction__bar-item'>
                  {status?.get('reblogs_count')}
                </span>
              </div>)}
            </div>

            {status?.get('favourites_count') > 0 && (
              <div
                className='status_action-bar__favourite-wrapper'
                onMouseEnter={this.handleFavouriteMouseEnter}
                onMouseLeave={this.handleFavouriteMouseLeave}
                onClick={this.handleFavouriteTooltip}
                ref={this.setRef}
              >
                {status?.get('favourites_list') && status?.get('favourites_list').size > 0 && (
                  <>
                    {status?.get('favourites_list').slice(0, 2).map((account, index) => (
                      <Avatar key={account.get('id')} account={account} size={32} />
                    ))}
                    {status?.get('favourites_count') >= 3 && (
                      <div className='other'>+{status?.get('favourites_count') - 2}</div>
                    )}
                  </>
                )}

                {this.renderFavouritesTooltip(status)}
              </div>
            )}

            <div className='status_more_button'>
              <DropdownMenuContainer
                scrollKey={scrollKey}
                status={status}
                items={menu}
                icon='ellipsis-h'
                iconComponent={MoreHorizIcon}
                direction='right'
                title={intl.formatMessage(messages.more)}
              />
            </div>
          </div>
        )}
      </>
    );

    const detailActionBar = (
      <div className='detailed-status__action-bar-wrapper'>
        <div className='detailed-status__action-bar-wrapper-inner'><Comment_form_container replyDisplayName={status?.getIn(['account', 'display_name'])} replyAccountName={status?.getIn(['account', 'username'])} replyToId={status?.get('id')}
          expandReply={this.props.expandReply}
          isReply isReplyComment /></div>
      </div>
    );

    const showReplyCommentForm = this.props.commentId === this.props.status?.get('id');

    const replyActionBar = (
      <>
        {this.props.replyLevel >= 1 ? (
          <div className='status__action-bar'>
            <div className='comment__action-bar'>
              <div className='status__action-bar__button-wrapper'
                style={this.props.isComment && {
                  backgroundColor: 'transparent !important',
                  padding: '0 !important',
                  position: 'absolute',
                  right: '0'
                }}
              >
                <IconButton className='status__action-bar__button' animate active={status?.get('favourited')}
                  title={favouriteTitle} icon='star'
                  iconComponent={status?.get('favourited') ? LikeActiveIcon : LikeIcon}
                  onClick={this.handleFavouriteClick} style={{ touchAction: 'manipulation', userSelect: 'none' }} counter={status?.get('favourites_count')} />
              </div>
              <RelativeTimestamp timestamp={this.props.status?.get('created_at')} />
              <div className='status__action-bar__button-wrapper'>
                <IconButton className='status__action-bar__button' title={replyTitle} icon={isReply ? 'reply' : replyIcon}
                  iconComponent={this.props.isComment ? null : CommentIcon} onClick={this.handleReplyCommentClick}
                  label={this.props.intl.formatMessage(messages.reply)}
                  style={{
                    'fontSize': '13px',
                    'fontWeight': '400',
                  }}
                />
              </div>
              <DropdownMenuContainer
                scrollKey={scrollKey}
                status={status}
                items={menu}
                icon='ellipsis-h'
                iconComponent={MoreHorizIcon}
                direction='right'
                title={intl.formatMessage(messages.more)}
                isComment={this.props.isComment}
              />
            </div>
          </div>
        ) : (
          <div className='status__action-bar'>
            <div className='comment__action-bar'>
              <div className='status__action-bar__button-wrapper'
                style={this.props.isComment && {
                  backgroundColor: 'transparent !important',
                  padding: '0 !important',
                  position: 'absolute',
                  right: '0'
                }}
              >
                <IconButton className='status__action-bar__button ' animate active={status?.get('favourited')}
                  title={favouriteTitle} icon='star'
                  iconComponent={status?.get('favourited') ? LikeActiveIcon : LikeIcon}
                  onClick={this.handleFavouriteClick} style={{ touchAction: 'manipulation', userSelect: 'none' }} counter={status?.get('favourites_count')} />
              </div>
              <div className='status__action-bar__button-wrapper'
                style={this.props.isComment && {
                  backgroundColor: 'transparent !important',
                  padding: '0 !important',
                }}
              >
                <IconButton className='status__action-bar__button' title={this.props.isComment ? this.props.intl.formatMessage(messages.reply) : replyTitle} icon={isReply ? 'reply' : replyIcon}
                  iconComponent={this.props.isComment ? null : CommentIcon} onClick={this.handleReplyCommentClick}
                  label={this.props.intl.formatMessage(messages.reply)}
                  style={{
                    'fontSize': '13px',
                    'fontWeight': '400',
                  }}
                />
              </div>
              <DropdownMenuContainer
                scrollKey={scrollKey}
                status={status}
                items={menu}
                icon='ellipsis-h'
                iconComponent={MoreHorizIcon}
                direction='right'
                title={intl.formatMessage(messages.more)}
                isComment={this.props.isComment}
              />
            </div>
          </div>
        )}
        {showReplyCommentForm && (window.innerWidth <= 768 ? createPortal(detailActionBar, document.body) : detailActionBar)}
        {this.props.childRepliesSize !== 0 && (this.props.replyLevel < 2) && (
          <span
            className='comment__expanded'
            onClick={handleShowReply}
          >
            {this.props.isReplyExpand
              ? this.props.intl.formatMessage(messages.hideReply)
              : this.props.intl.formatMessage(messages.showMoreReply, { count: this.props.childRepliesSize })}
            {this.props.isReplyExpand ? (
              <ExpandUpIcon />
            ) : (
              <ExpandDownIcon />
            )}
          </span>)}
      </>
    );

    return (
      isReplyTo ? replyActionBar : postActionBar
    );
  }

}

export default withRouter(withIdentity(connect(mapStateToProps)(injectIntl(StatusActionBar))));
